import { Controller } from "@hotwired/stimulus"
import { backAction } from "../lib/back_navigation"

/**
 * Navigation Controller
 *
 * Handles browser history navigation (back/forward) in a CSP-compliant way.
 * Replaces javascript: URLs which violate Content Security Policy.
 *
 * Usage:
 *   <button data-controller="navigation" data-action="click->navigation#back">
 *     Back
 *   </button>
 *
 *   <button data-controller="navigation"
 *           data-action="click->navigation#back"
 *           data-navigation-fallback-url-value="/products">
 *     Back (with fallback)
 *   </button>
 *
 *   <button data-controller="navigation" data-action="click->navigation#forward">
 *     Forward
 *   </button>
 */
export default class extends Controller {
  static values = {
    fallbackUrl: { type: String, default: "/products" },
    forceFallback: { type: Boolean, default: false }
  }

  // ←: native pop in the shells; web history.back() when there's an in-app entry, else replace to the fallback.
  back(event) {
    event.preventDefault()

    const action = backAction({
      native: navigator.userAgent.includes("Turbo Native"),
      restorationIndex: window.history.state?.turbo?.restorationIndex,
      fallbackUrl: this.fallbackUrlValue,
      forceFallback: this.forceFallbackValue
    })

    if (action.type === "history") {
      window.history.back()
    } else if (window.Turbo) {
      Turbo.visit(action.url, action.type === "replace" ? { action: "replace" } : {})
    } else {
      window.location.href = action.url
    }
  }

  /**
   * Navigate forward in browser history
   * @param {Event} event - Click event
   */
  forward(event) {
    event.preventDefault()
    window.history.forward()
  }
}
